import { globalAxios } from "@/axios-path.js";
// fetchStorePaymentReport
export default {
  namespaced: true,
  state: {
    config_path: {
      search_store_id: 0,
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    clone_config_path: {
      search_store_id: 0,
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    clone_store_payment_list: [],
    store_payment_list: [],
    store_payment_summary: {},
    export_form_store_payment: [],
    order_store_list: [],
    order_store_summary: {},
    export_form_order_store: [],
  },
  mutations: {
    resetState(state) {
      state.config_path = {
        search_store_id: 0,
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.clone_config_path = {
        search_store_id: 0,
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.store_payment_list = [];
      state.clone_store_payment_list = [];
      state.store_payment_summary = {};
      state.export_form_store_payment = [];
      state.order_store_list = [];
      state.order_store_summary = {};
      state.export_form_order_store = [];
    },
    calTotalpaid(state) {
      let total_paid = {
        total: 0,
        index: -1,
      };
      for (let val of state.store_payment_list) {
        let index = state.store_payment_list.indexOf(val);
        if (val.store_name) {
          total_paid.index = index;
          total_paid.total = parseFloat(val.amount_paid);
        } else {
          total_paid.total += parseFloat(val.amount_paid);
        }
        state.store_payment_list[total_paid.index].total_paid =
          total_paid.total;
      }
    },
    clearOrderState(state) {
      state.order_store_list = [];
      state.order_store_summary = {};
      state.export_form_order_store = [];
    },
    getOrderStoreReport(state, data) {
      state.order_store_list = data;
      let count_no = 1;
      for (let val of state.order_store_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getOrderStoreSummary(state, data) {
      state.order_store_summary = data;
    },
    getExportFormOrderStore(state) {
      state.export_form_order_store = [];
      for (let val of state.order_store_list) {
        let index = state.order_store_list.indexOf(val);
        let json_push = {
          No: index + 1,
          order_code: val.order_code,
          order_base_code: val.order_base_code,
          order_time_start: val.order_time_start,
          order_note: val.order_note,
          summary: parseFloat(val.summary)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        };
        state.export_form_order_store.push(json_push);
      }
    },
    getExportOrderStoreSummary(state) {
      state.export_form_order_store.push({
        store_name: "Total",
        summary: parseFloat(state.order_store_summary.summary)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        deduction: parseFloat(state.order_store_summary.deduction)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        amount_paid: parseFloat(state.order_store_summary.amount_paid)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      });
    },
    resetStoreList(state) {
      state.store_payment_list = JSON.parse(
        JSON.stringify(state.clone_store_payment_list)
      );
    },
    getStoreListReport(state, data) {
      state.store_payment_list = data;
      let count_no = 1;
      for (let val of state.store_payment_list) {
        if (val.store_name) {
          val.no = count_no++;
          val.no_default = count_no - 1;
        } else {
          val.no = null;
          val.no_default = count_no - 1;
        }
      }
    },
    cloneStoreList(state) {
      state.clone_store_payment_list = JSON.parse(
        JSON.stringify(state.store_payment_list)
      );
    },
    getStorePaymentSummary(state, data) {
      state.store_payment_summary = data;
    },
    getExportFormStorePayment(state) {
      state.export_form_store_payment = [];
      let count_no = 1;
      for (let val of state.store_payment_list) {
        let json_push = {
          No: val.store_name ? count_no++ : "",
          store_name: val.store_name,
          package: val.package,
          order_type: val.order_type,
          bank_no: val.bank_no,
          bank_name: val.bank_name,
          bank_type: val.bank_type,
          circulation: val.circulation
            ? parseFloat(val.circulation)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          commission: val.commission,
          deduction: val.deduction
            ? parseFloat(val.deduction)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          amount_paid: val.amount_paid
            ? parseFloat(val.amount_paid)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          total_paid: val.total_paid
            ? parseFloat(val.total_paid)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "",
        };
        state.export_form_store_payment.push(json_push);
      }
    },
    getExportFormSummary(state) {
      state.export_form_store_payment.push({
        store_name: "Total",
        circulation: parseFloat(state.store_payment_summary.circulation)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        deduction: parseFloat(state.store_payment_summary.deduction)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        amount_paid: parseFloat(state.store_payment_summary.amount_paid)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        total_paid: parseFloat(state.store_payment_summary.total_paid)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      });
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
    calStorePaymentSummary(state) {
      state.store_payment_summary.circulation = 0;
      state.store_payment_summary.deduction = 0;
      state.store_payment_summary.amount_paid = 0;
      state.store_payment_summary.total_paid = 0;
      for (let val of state.store_payment_list) {
        state.store_payment_summary.circulation += parseFloat(val.circulation);
        state.store_payment_summary.deduction += parseFloat(val.deduction);
        state.store_payment_summary.amount_paid += parseFloat(val.amount_paid);
        if (val.total_paid) {
          state.store_payment_summary.total_paid += parseFloat(val.total_paid);
        }
      }
      state.store_payment_summary.circulation = state.store_payment_summary.circulation.toFixed(
        2
      );
      state.store_payment_summary.deduction = state.store_payment_summary.deduction.toFixed(
        2
      );
      state.store_payment_summary.amount_paid = state.store_payment_summary.amount_paid.toFixed(
        2
      );
      state.store_payment_summary.total_paid = state.store_payment_summary.total_paid.toFixed(
        2
      );
    },
  },
  actions: {
    async filterDataReport({ commit }, send_json_data) {
      let store_name_replace = "";
      let no_replace = "";
      for (let value of send_json_data.data) {
        if (value.store_name) {
          store_name_replace = value.store_name;
        } else {
          value.store_name = store_name_replace;
        }
        if (value.no) {
          no_replace = value.no;
        } else {
          value.no = no_replace;
        }
      }
      let obj = send_json_data.data.filter((val) => {
        return val.package == send_json_data.field;
      });

      store_name_replace = "";
      no_replace = "";

      for (let value of obj) {
        if (value.store_name == store_name_replace) {
          value.store_name = "";
        } else {
          store_name_replace = value.store_name;
        }
        if (value.no == no_replace) {
          value.no = "";
        } else {
          no_replace = value.no;
        }
      }
      commit("getStoreListReport", obj);
      return obj;
    },
    async getStoreListReport({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchStorePaymentReport_getStoreListReportNew +
        config_path.search_store_id +
        "/" +
        config_path.order_status +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("cloneConfigPath");
        commit("getStoreListReport", res.data);
        commit("calTotalpaid");
        commit("cloneStoreList");
        commit("calStorePaymentSummary");
        commit("getExportFormStorePayment");
        commit("getExportFormSummary");
      }
    },
    fetchReportByDistrict({ rootState, state, dispatch, commit }) {
      let url = `/api/v1/${
        rootState.backOffice.province
      }/search_by_district/store_payment_report/store_id/order_status/datetime_start/datetime_end/${
        state.config_path.search_store_id
      }/${state.config_path.order_status}/${state.config_path.datetime_start}/${
        state.config_path.datetime_end
      }`;

      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("cloneConfigPath");
          commit("getStoreListReport", res.data);
          commit("calTotalpaid");
          commit("cloneStoreList");
          commit("calStorePaymentSummary");
          commit("getExportFormStorePayment");
          commit("getExportFormSummary");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getOrderStoreReport({ commit, rootState, dispatch }, config_path) {
      let url = "";
      if (config_path.order_type == "FR") {
        url =
          rootState.api_urls.fetchStorePaymentReport_getOrderStoreReportFree +
          config_path.search_store_id +
          "/" +
          config_path.order_status +
          "/" +
          config_path.datetime_start +
          "/" +
          config_path.datetime_end;
      } else {
        url =
          rootState.api_urls.fetchStorePaymentReport_getOrderStoreReport +
          config_path.search_store_id +
          "/" +
          config_path.order_status +
          "/" +
          config_path.datetime_start +
          "/" +
          config_path.datetime_end;
      }
      commit("clearOrderState");
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("cloneConfigPath");
        commit("getOrderStoreReport", res.data);
        commit("getOrderStoreSummary", res.calculate);
        commit("getExportFormOrderStore");
        commit("getExportOrderStoreSummary");
      }
    },
  },
  getters: {},
};
